export default [
  // Authenticated routes.
  ...middleware('auth', [
    { path: '/', name: 'home', component: require('~/pages/home_apo_one').default },
    {
      path: '/sandoz/apo_one/contracts',
      component: require('~/pages/sandoz/apo_one/ContractList').default,
      name: 'sandoz.apo_one.contracts'
    },
    {
      path: '/sandoz/apo_one/contracts/:id',
      component: require('~/pages/sandoz/apo_one/ContractDetail').default,
      name: 'sandoz.apo_one.contract_detail'
    },
    {
      path: '/settings', component: require('~/pages/settings/index').default,
      children: [
        { path: '', redirect: { name: 'settings.profile' } },
        { path: 'profile', name: 'settings.profile', component: require('~/pages/settings/profile').default },
        { path: 'password', name: 'settings.password', component: require('~/pages/settings/password').default }
      ]
    },
    {
      path: '/system', component: require('~/pages/system/index').default,
      children: [
        {path: 'apo_one_users', name: 'system.apo_one_user_list', component: require('~/pages/system/ApoOneUserList').default},
        {path: 'apo_one_users/:id', name: 'system.apo_one_user_detail', component: require('~/pages/system/ApoOneUserDetail').default},
        {path: 'apo_one_addresses', name: 'system.apo_one_address_list', component: require('~/pages/system/ApoOneAddressList').default},
        {path: 'apo_one_addresses/:id', name: 'system.apo_one_address_list_detail', component: require('~/pages/system/ApoOneAddressDetail').default}
      ]
    },
  ]),

  // Guest routes.
  ...middleware('guest', [
    { path: '/login', name: 'login', component: require('~/pages/auth/login').default },
    { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email').default },
    {
      path: '/password/reset/:token',
      name: 'password.reset',
      component: require('~/pages/auth/password/reset').default
    },
    {path: '/two-factor-auth', name: 'two-factor-auth', component: require('~/pages/auth/TwoFactorAuth').default},
  ]),

  { path: '*', component: require('~/pages/errors/404.vue').default }
]

/**
 * @param  {String|Function} middleware
 * @param  {Array} apoOneRoutes
 * @return {Array}
 */
function middleware (middleware, apoOneRoutes) {
  apoOneRoutes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  )

  return apoOneRoutes
}
